import { TFeature } from '../../../../common/types/map';

export function getFeatureWithSelectedState(feature: TFeature, activeOfferId: number | null | undefined): TFeature {
  const isSelectedFeature =
    activeOfferId != null && feature.properties.offers.some(offer => offer.realtyId === activeOfferId);

  if (isSelectedFeature) {
    if (feature.properties.isActive) {
      return feature;
    }

    return {
      ...feature,
      properties: { ...feature.properties, isActive: true },
    };
  }

  if (!feature.properties.isActive) {
    return feature;
  }

  return {
    ...feature,
    properties: { ...feature.properties, isActive: false },
  };
}
